import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { TimeoutModalComponent } from '@shared/components/timeout-modal/timeout-modal.component';
import { ModalService } from '@shared/services';
import { DrawerManagerService } from '@shared/services/drawer/drawer-manager.service';
import { Subject } from 'rxjs';
import { RefreshTokenResponse } from '../web-api-client';
import { AuthService } from './services/auth.service';
import { EnvironmentsService } from './services/environments/environments.service';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutService {
  private readonly router = inject(Router);
  private readonly idle = inject(Idle);
  private readonly environmentService = inject(EnvironmentsService);
  private readonly authService = inject(AuthService);
  private readonly modalService = inject(ModalService);
  private readonly drawerManagerService = inject(DrawerManagerService);

  readonly closeSession$ = new Subject<void>();

  constructor() {
    this.idle.onIdleStart.subscribe(() => this.sessionTimeOutStart());
    this.authService.logout$.subscribe(() => this.idle.stop());
  }

  sessionInitialize(): void {
    if (!this.idle.isRunning()) {
      this.idle.setIdle(this.environmentService.sessionTime);
      this.idle.setTimeout(this.environmentService.timeBeforeClose);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.reset();
    }
  }

  private sessionTimeOutStart(): void {
    this.idle.setInterrupts([]);
    const modalSetting = {
      appModalId: 'timeout-modal',
    };

    const modal = this.modalService.open(TimeoutModalComponent, modalSetting);
    modal.instance
      .afterClosed()
      .subscribe((isConfirm: boolean) =>
        this.afterCloseSessionOutModal(isConfirm)
      );
  }

  private closeSession(): void {
    this.idle.stop();
    this.drawerManagerService.close();
    this.authService.logout().subscribe(() => {
      this.closeSession$.next();
      this.router.navigate(['/login']);
    });
  }

  private afterCloseSessionOutModal(isConfirm: boolean): void {
    if (isConfirm) {
      this.authService
        .regreshToken()
        .subscribe((response: RefreshTokenResponse) => {
          this.authService.saveTokenSession(response);
          this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
          this.reset();
        });
    } else {
      this.closeSession();
    }
  }

  private reset(): void {
    this.idle.watch();
  }
}
